<template>
	<div class="templateEditor">
		<el-card class="top_card">
			<el-dropdown trigger="click" placement="bottom" @command="reportChange">
				<span class="el-dropdown-link">
					{{ selectedReportInfo.name }}<i class="el-icon-arrow-down el-icon--right"></i>
				</span>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item v-for="(item, index) in reportList" :key="index" :command="item">{{
						item.name
					}}</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
			<el-button type="primary" @click="reportTemplateDimensionSave" :loading="saveLoading"
				>保存</el-button
			>
		</el-card>

		<div class="bottom_card">
			<div class="left_body">
				<div class="dimension">
					<div class="title">维度</div>
					<div
						:class="isChoose(item, true) ? 'item isChoose' : 'item'"
						v-for="item in showConfig.dimension"
						@click="dimensionChoose(item)"
					>
						<img class="imgItem" :src="item.icon" alt="" />{{ item.label }}
					</div>
				</div>
				<div class="indicators">
					<div class="title">指标</div>
					<div
						:class="isChoose(item) ? 'item isChoose' : 'item'"
						v-for="item in showConfig.indicators"
						@click="indicatorsChoose(item)"
					>
						<img class="imgItem" :src="item.icon" alt="" />{{ item.label }}
					</div>
				</div>
			</div>
			<div class="right_body">
				<dragDropTop @preview="preview" v-model="templateReportDetails"></dragDropTop>
				<el-card class="bottom_card">
					<data-list
						:table-style="{ name: 'mixture' }"
						:data="data"
						:columns="columns"
						:loading="loading"
						height="500px"
						:page="page"
						:page-size="page.pageSize"
						@page-size-changed="pageSizeChanged"
						@page-changed="pageChanged"
					></data-list>
				</el-card>
			</div>
		</div>
	</div>
</template>

<script>
import reportConfiguration, { reportEnumeration } from './js/reportConfiguration';
import dragDropTop from './dragDropTop.vue';

import googleads from '@/backend/services/googleAds/googleAds.js';

import listPageCreate from '@/mixins/listPageCreate';

const list = listPageCreate({
	searchConfig: {
		method: 'POST',
		customApi(self) {
			let { templateReportDetails } = self;
			let { type } = templateReportDetails;
			return reportConfiguration[type - 1].previewApi;
		},
	},
	setExtension(self, query) {
		let params = {};
		let { id: detailsId, indexDTO: dto, falgSummaryRow } = self.templateReportDetails;
		if (dto.chooseMap.type && dto.chooseMap.type.includes('all')) {
			let list = dto.chooseMap.type.filter(item => {
				return item !== 'all';
			});
			dto.chooseMap.type = dto.chooseMap.type.includes('all') ? [0, 1, 4, ...list] : list;
		}
		params = {
			detailsId,
			falgSummaryRow,
			dto,
			...self.formData,
		};
		return {
			bodyParam: {
				...query,
				...params,
			},
			config: {
				timeout: 60000,
			},
		};
	},
});

export default {
	name: 'templateEditor',
	components: {
		dragDropTop,
	},
	mixins: [list],
	data() {
		return {
			reportList: [],
			selectedReportInfo: {},
			templateReportDetails: {},
			showConfig: {},
			saveLoading: false,
			params: {},
			formData: null,
		};
	},
	computed: {
		columns(self) {
			let list = [];
			let { indexDTO, type } = self.templateReportDetails;
			if (!indexDTO) return [];
			let { dimensionList, indexList } = indexDTO;
			dimensionList.forEach(item => {
				let object = reportConfiguration[type - 1].dimension.find(_item => {
					return _item.value === item;
				});
				if (object) {
					list.push({
						label: object.label,
						bind: object.bind || item,
					});
				}
			});
			indexList.forEach(item => {
				let label = reportConfiguration[type - 1].indicators.find(_item => {
					return _item.value === item;
				}).label;
				list.push({
					label,
					bind: item !== 'costMicros' ? `${item}Format` : 'cost',
				});
			});
			return list;
		},
	},
	watch: {
		selectedReportInfo: {
			handler(val) {
				this.getTemplateReportDetails(val);
			},
			deep: true,
		},
	},
	mounted() {
		this.getTemplateDetails();
	},
	methods: {
		// 获取模板详情
		async getTemplateDetails() {
			let { id } = this.$route.query;
			let { data } = await googleads.getTemplateDetail({ id });
			this.reportList = data.detailsList
				.filter(item => {
					return item.status;
				})
				.map(item => {
					return {
						...item,
						name: reportEnumeration[item.type - 1],
					};
				});
			this.selectedReportInfo = this.reportList[0];
		},
		// 获取模板配置详情
		async getTemplateReportDetails(val) {
			let { id: detailsId } = val;
			let { data } = await googleads.templateReportDetails({ detailsId });
			if (!data.indexDTO) {
				data.indexDTO = {
					chooseMap: null,
					dimensionList: [],
					indexList: [],
					orderList: [],
					orderWay: null,
				};
			}

			if (data.indexDTO.chooseMap.type) {
				data.indexDTO.chooseMap.type = data.indexDTO.chooseMap.type.map(item => {
					return item - 0;
				});
				if (
					data.indexDTO.chooseMap.type.includes(0) ||
					data.indexDTO.chooseMap.type.includes(1) ||
					data.indexDTO.chooseMap.type.includes(4)
				) {
					let list = data.indexDTO.chooseMap.type.filter(item => {
						return ![0, 1, 4].includes(item);
					});
					data.indexDTO.chooseMap.type = ['all', ...list];
				}
			}
			this.templateReportDetails = data;
			this.setShowConfig(val);
			this.resetList();
			this.preview();
		},
		// 切换显示配置
		setShowConfig(val) {
			let { type } = val;
			this.showConfig = reportConfiguration[type - 1];
		},
		// 报告切换
		reportChange(info) {
			this.selectedReportInfo = info;
		},
		// 判断是否已选择
		isChoose(val, type) {
			return this.templateReportDetails.indexDTO[type ? 'dimensionList' : 'indexList'].includes(
				val.value
			);
		},
		// 维度选择
		dimensionChoose(val) {
			if (this.isChoose(val, true)) return;
			this.templateReportDetails.indexDTO.dimensionList.push(val.value);
		},
		// 指标选择
		indicatorsChoose(val) {
			if (this.isChoose(val)) return;
			this.templateReportDetails.indexDTO.indexList.push(val.value);
		},
		// 报告保存函数
		async reportTemplateDimensionSave() {
			this.saveLoading = true;
			try {
				let { id: detailsId } = this.templateReportDetails;
				let data = _.cloneDeep(this.templateReportDetails);
				if (data.indexDTO.chooseMap.type && data.indexDTO.chooseMap.type.includes('all')) {
					let list = data.indexDTO.chooseMap.type.filter(item => {
						return item !== 'all';
					});
					data.indexDTO.chooseMap.type = data.indexDTO.chooseMap.type.includes('all')
						? [0, 1, 4, ...list]
						: list;
				}
				await googleads.reportTemplateDimension({
					detailsId,
					...data,
				});
				this.$message.success('保存成功');
			} catch (err) {
				this.$message.warning('保存失败');
			}
			this.saveLoading = false;
		},
		// 报告预览
		preview(data) {
			if (data) {
				delete data.cancel;
				delete data.defaultKey;
				delete data.time;
				delete data.customerId;
				this.formData = data;
			}
			if (this.formData) {
				this.query();
			}
		},
		resetList() {
			this.data = [];
			this.page = {
				currentPage: 1,
				totalRecords: 0,
				pageSize: 10,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.templateEditor {
	::v-deep  .top_card {
		.el-card__body {
			display: flex;
			justify-content: space-between;
			align-items: center;

			.el-dropdown {
				cursor: pointer;
			}
		}
	}

	.bottom_card {
		display: flex;
		margin-top: 10px;
		// height: calc(100vh - 220px);

		.left_body {
			flex: 2;
			width: 0;
			margin-right: 15px;
			background: #ffffff;
			box-shadow: 0px 4px 4px 0px rgba(67, 93, 255, 0.05);
			overflow: auto;

			// 改变滚动条样式
			&::-webkit-scrollbar {
				width: 5px;
				height: 5px;
			}

			&::-webkit-scrollbar-thumb {
				background-color: #e8e8e8;
				height: 50px;
				border-radius: 6px;
			}

			&::-webkit-scrollbar-track {
				background-color: #fff;
				border-radius: 2px;
			}

			.title {
				height: 40px;
				background: #fafafa;
				margin-top: 20px;
				font-size: 15px;
				font-weight: 400;
				color: rgba(0, 0, 0, 0.85);
				padding-left: 20px;
				display: flex;
				align-items: center;
				margin: 10px 0;
			}

			.item {
				padding: 5px 0;
				display: flex;
				align-items: center;
				font-size: 14px;
				font-weight: 400;
				color: #333333;
				margin: 5px 20px;
				cursor: pointer;

				&:hover {
					background: rgb(231, 240, 255);
				}

				.iconfont {
					font-size: 20px;
					margin-right: 5px;
					margin-left: 5px;
				}
			}

			.isChoose {
				background: rgb(231, 240, 255) !important;
			}

			.active {
			}
		}

		.right_body {
			flex: 8;
			width: 0;

			.bottom_card {
				::v-deep  .el-card__body {
					width: 100%;
				}
			}
		}

		.imgItem {
			width: 19px;
			margin: 0 5px;
		}
	}
}
</style>
